import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    status: '',
    token: '',
    user : {}
  },
  mutations: {
    auth_request(state){
        state.status = 'loading';
    },
    auth_success(state, token, user) {
        state.status = 'success';
        state.token = token;
        state.user = user;
    },
    auth_error(state) {
        state.status = 'error';
    },
    logout(state) {
        state.status = '';
        state.token = '';
    },
  },
  actions: {
    login({commit}, user) {
        return new Promise((resolve, reject) => {
          commit('auth_request')
          var url = process.env.VUE_APP_HOST + process.env.VUE_APP_PATH_AUTH + '/login';
          axios({url: url, data: user, method: 'POST' })
          .then(resp => {
              const data = resp.data;
              if (data.auth === true) {
                const token = data.token;
                const user = data.user;
                Vue.localStorage.set('token', token, String);
                Vue.localStorage.set('user', JSON.stringify(user), String);
                if (user.access.key) {
                  Vue.localStorage.set('access-key', user.access.key, String);
                  axios.defaults.headers.common['Authorization'] = user.access.key;
                }
                commit('auth_success', token, user);
                resolve(resp);
              } else {
                commit('auth_error');
                Vue.localStorage.remove('token');
                Vue.localStorage.remove('user');
                delete axios.defaults.headers.common['Authorization'];
                reject(data.message);
              }
          })
          .catch(err => {
            commit('auth_error');
            Vue.localStorage.remove('token');
            Vue.localStorage.remove('user');
            delete axios.defaults.headers.common['Authorization'];
            reject(err);
          })
        })
    },
    logout({commit}) {
        return new Promise((resolve) => {
          commit('logout');
          Vue.localStorage.remove('token');
          Vue.localStorage.remove('user');
          delete axios.defaults.headers.common['Authorization'];
          resolve();
        });
    },
  },
  getters : {
    isLoggedIn: state => (state.status === 'success'),
    authStatus: state => state.status,
  }
});

export default store;